export default __webpack_public_path__ + "eaf62d941377cc0935d171389953888f.png";